import Vue from 'vue'
import Router from 'vue-router'
import apneaHebrew from '@/components/apneaHebrew'

// import underConstruction from '@/components/underConstruction'
// import mainPage from '@/components/mainPage'
import vWow from 'v-wow'
Vue.use(vWow);

Vue.use(Router)

export default new Router({
  mode: 'history',

  routes: [{
    path: '/apneaHebrew',
    name: 'apneaHebrew',
    component: apneaHebrew
  },
  {
    path: '/',
    name: 'apneaHebrew',
    component: apneaHebrew
  }
  ]
})